import React from 'react';
import { Typography } from '@material-ui/core';
import { renderAnswer } from './renderAnswer';
export var AnswerContent = function (_a) {
    var className = _a.className, contents = _a.contents, skillApi = _a.skillApi, cardId = _a.cardId;
    return (React.createElement("div", { className: "faq-answer-content__answer-wrapper" }, contents.map(function (content, i) {
        if (!content) {
            return null;
        }
        return (React.createElement(Typography, { key: "".concat(i, "--").concat(content.text), paragraph: true, component: "div", className: className }, renderAnswer(content, skillApi, cardId)));
    })));
};
//# sourceMappingURL=AnswerContent.js.map